var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "width": "400",
      "value": true
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    staticClass: "pt-4 px-4 pb-0"
  }, [_vm._v(_vm._s(_vm.canUpdate ? 'Add to g' : 'G') + "ift card")]), (_vm.order.n_giftcard_recipients || 1) > 1 ? _c('v-card-subtitle', {
    staticClass: "mt-0 px-4 py-0"
  }, [_vm._v(" This gift card will be sent to " + _vm._s(_vm._f("pl")(_vm.order.n_giftcard_recipients, 'recipient')) + " ")]) : _vm._e(), _vm.userAmtAdded ? _c('v-card-subtitle', {
    staticClass: "mt-0 px-4 py-0"
  }, [_vm._v(" Amount you already contributed: "), _c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.userAmtAdded) + " ")], 1) : _vm._e(), _c('v-card-subtitle', {
    staticClass: "mt-6 px-4"
  }, [_c('v-card', {
    staticClass: "float-right ml-4 mb-1 gc-border",
    attrs: {
      "width": "100"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 337 / 213,
      "src": _vm.blob.giftcard.product_img
    }
  })], 1), _c('div', {
    staticClass: "overline short",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.blob.giftcard.product_name)
    }
  }), _c('giftcard-details', {
    attrs: {
      "src": _vm.blob.giftcard.src,
      "product-id": _vm.blob.giftcard.product_id
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('v-divider'), _c('v-row', {
    staticClass: "ma-1 mb-3 d-flex"
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('div', {
    staticClass: "text--label-active mb-1"
  }, [_vm._v("Current value")]), _c('v-btn', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "green lighten-2"
    }
  }, [_c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.blob.giftcard.amt) + " ")], 1)], 1), _c('v-col', {
    staticClass: "d-flex flex-column justify-end align-center",
    attrs: {
      "cols": "2"
    }
  }, [_vm.amtValid ? _c('v-btn', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "rounded": "",
      "dark": "",
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.6) !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiArrowRightThin)
    }
  })], 1) : _vm._e()], 1), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "5"
    }
  }, [_c('div', {
    staticClass: "text--label-active mb-1"
  }, [_vm._v("New value")]), _c('v-btn', {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "rounded": "",
      "color": "green",
      "dark": !!_vm.amtValid,
      "disabled": !_vm.amtValid
    }
  }, [_c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.blob.giftcard.amt + (_vm.amtValid ? _vm.amt : 0)) + " ")], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm.locked ? _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This order has been locked – this gift card can't be updated. ")], 1) : _vm.blob.giftcard.claim_id ? _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This gift card has already been claimed – it can't be updated. ")], 1) : !_vm.allowedValues ? _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This gift card is already at it's maximum value – it can't be updated. ")], 1) : _vm.blob.sample ? _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This is a demo group gift card – it can't be updated. ")], 1) : _vm.userAmtAdded && !_vm.didAckUserAmtAdded ? _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" You already contributed "), _c('currency', {
    attrs: {
      "code": _vm.blob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.userAmtAdded) + " to this gift card. Are you sure you want to contribute more? "), _c('div', {
    staticClass: "mt-6 d-flex justify-end"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.didAckUserAmtAdded = true;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : [_c('div', {
    staticClass: "px-4 text--label-active mb-n4"
  }, [_vm._v("Add amount")]), _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('v-form', {
    class: {
      'py-8': _vm.allowedValues.fixed
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.amtValid,
      callback: function ($$v) {
        _vm.amtValid = $$v;
      },
      expression: "amtValid"
    }
  }, [_c('giftcard-amount', {
    attrs: {
      "allowed-values": _vm.allowedValues,
      "cur": _vm.blob.giftcard.cur,
      "max": _vm.maxValue
    },
    model: {
      value: _vm.amt,
      callback: function ($$v) {
        _vm.amt = $$v;
      },
      expression: "amt"
    }
  })], 1)], 1), !_vm.blob.sample ? [_c('v-divider'), _vm.amtValid ? _c('payment', {
    staticClass: "py-4 mx-auto",
    staticStyle: {
      "min-height": "414px"
    },
    attrs: {
      "passive-sign-in": "",
      "metadata": _vm.paymentMetadata
    },
    on: {
      "complete": _vm.onComplete
    }
  }) : _c('div', {
    staticStyle: {
      "min-height": "414px"
    }
  })] : _vm._e()]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }